import { createFileRoute } from '@tanstack/react-router'

// The parent route renders the page with this chat open.
export const Route = createFileRoute('/_authenticated/customer-comms/store-ai/$chatId')({
  staticData: { title: 'Store AI', phoneFullScreen: true },
  component: () => null,
})
